// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const accordionTargetHeaders = document.querySelectorAll('.js-accordion');

    /**
     * Add event listener on all the accordion headers
     * Slide up all the accordion headers
     * Slide down only the targeted header if it's not active
     */

    for (const accordionTargetHeader of accordionTargetHeaders) {

        accordionTargetHeader.addEventListener('click', (e) => {

            const accordionTargetItem = e.target.parentNode.closest('.accordion');
            const accordionTargetCollapse = accordionTargetItem.querySelector('.accordion__secondary');
            const accordionList = accordionTargetItem.closest('.accordions__list');
            const accordionCollapses = accordionList ? accordionList.querySelectorAll('.accordion__secondary') : [];

            // All accordion items
            for(const accordionCollapse of accordionCollapses) {
                if (accordionCollapse != accordionTargetCollapse) {
                    const accordionItem = accordionCollapse.closest('.accordion');
                    accordionSlideUp(accordionItem, accordionCollapse);
                }
            }

            // Targeted accordion item
            if (accordionTargetItem.classList.contains('accordion--active')) {
                accordionSlideUp(accordionTargetItem, accordionTargetCollapse);
            } else {
                accordionSlideDown(accordionTargetItem, accordionTargetCollapse);
            }

        });

    }

    /**
     * Accordion slide down
     */

    const accordionSlideDown = (item, collapse) => {

        item.classList.add('accordion--active');

        collapse.style.height = 'auto';
        const collapseHeight = collapse.clientHeight + 'px';
        collapse.style.height = '0px';
        setTimeout(function () {
            collapse.style.height = collapseHeight;
        }, 0);

    }

    /**
     * Accordion slide up
     */

    const accordionSlideUp = (item, collapse) => {

        collapse.style.height = '0px';

        item.classList.remove('accordion--active');

    }

});
